// Stimulus controller wrapping the Quill.js WYSIWYG editor (real npm package,
// bundled locally — no CDN). Binds the editor's HTML output to a hidden field
// so it posts normally with the surrounding Rails form.
import { Controller } from "@hotwired/stimulus"
import Quill from "quill"
import "quill/dist/quill.snow.css"

export default class extends Controller {
  static targets = ["editor", "hidden", "toolbar"]

  connect() {
    this.quill = new Quill(this.editorTarget, {
      theme: "snow",
      modules: { toolbar: this.toolbarTarget }
    })
    if (this.hiddenTarget.value) {
      this.quill.clipboard.dangerouslyPasteHTML(this.hiddenTarget.value)
    }
    this.quill.on("text-change", () => {
      this.hiddenTarget.value = this.quill.root.innerHTML
    })
  }
}
